import { render, staticRenderFns } from "./legend-item.vue?vue&type=template&id=1695b1a8&scoped=true"
import script from "./legend-item.vue?vue&type=script&lang=ts"
export * from "./legend-item.vue?vue&type=script&lang=ts"
import style0 from "./legend-item.vue?vue&type=style&index=0&id=1695b1a8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1695b1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1695b1a8')) {
      api.createRecord('1695b1a8', component.options)
    } else {
      api.reload('1695b1a8', component.options)
    }
    module.hot.accept("./legend-item.vue?vue&type=template&id=1695b1a8&scoped=true", function () {
      api.rerender('1695b1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/legend-item/legend-item.vue"
export default component.exports